/**
 * Helper function that returns the proper publisher logo to use for WebSite schema
 * @returns the publisher logo
 */
export const getWebSitePublisherLogo = () => 'https://media-cldnry.s-nbcnews.com/image/upload/h_60/v1696280688/newsgroup-logos/nbcnews/logo/primary-black-424x45.png';
